import { QuizType } from "./graphql/generated/graphql";

export const EMAIL_NO_REPLY = "no-reply@zerotofinals.com";

const ONE_DAY_IN_SECTIONS = 60 * 60 * 24;

export const PINNED_QUESTION_LIMIT = 1000;
export const MIN_PASSWORD_LENGTH = 8;
export const MAX_PASSWORD_LENGTH = 20;
export const MAX_FEEDBACK_LENGTH = 160;

export const AWS_S3_SIGNED_URL_EXPIRY = ONE_DAY_IN_SECTIONS;

export const protectedPaths = ["/dashboard", "/flashcards", "/how-to-learn-medicine", "/osce", "/quiz", "/tracker", "/results", "/fact-trainer", "/account"];

export const questionDataDir = new Map<QuizType, string>([
  [QuizType.Saq, "saq-questions"],
  [QuizType.Mcq, "mcq-questions"],
  [QuizType.Emq, "emq-questions"],
]);

export const STORAGE_KEY_FLASHCARDS_SELECTED_CATEGORIES = "active-categories-flashcards";
export const STORAGE_KEY_FLASHCARDS_PINNED_SELECTED_CATEGORIES = "active-categories-flashcards";
export const STORAGE_KEY_FLASHCARDS_SESSION_IDS = "active-flashcards";
export const STORAGE_KEY_FLASHCARDS_RANDOMISE_CATEGORIES = "randomise-categories";
export const STORAGE_KEY_FLASHCARDS_RANDOMISE_PINNED_CATEGORIES = "randomise-pinned-categories";

export const STORAGE_KEY_SAQ_SELECTED_CATEGORIES = "active-categories-saq";
export const STORAGE_KEY_SAQ_SESSION_IDS = "active-questions-saq";
export const STORAGE_KEY_SAQ_SKIPPED_IDS = "active-skipped-saq";
export const STORAGE_KEY_SAQ_PINNED_SELECTED_CATEGORIES = "active-categories-pinned-saq";
export const STORAGE_KEY_SAQ_PINNED_SESSION_IDS = "pinned-questions-saq";
export const STORAGE_KEY_SAQ_REPEAT_INCORRECT_SELECTED_CATEGORIES = "active-categories-repeat-incorrect-saq";
export const STORAGE_KEY_SAQ_REPEAT_INCORRECT_SESSION_IDS = "repeat-incorrect-questions-saq";
export const STORAGE_KEY_SAQ_REPEAT_INCORRECT_SKIPPED_IDS = "repeat-incorrect-skipped-saq";

export const STORAGE_KEY_MCQ_SELECTED_CATEGORIES = "active-categories-mcq";
export const STORAGE_KEY_MCQ_SESSION_IDS = "active-questions-mcq";
export const STORAGE_KEY_MCQ_SKIPPED_IDS = "active-skipped-mcq";
export const STORAGE_KEY_MCQ_PINNED_SELECTED_CATEGORIES = "active-categories-pinned-mcq";
export const STORAGE_KEY_MCQ_PINNED_SESSION_IDS = "pinned-questions-mcq";
export const STORAGE_KEY_MCQ_REPEAT_INCORRECT_SELECTED_CATEGORIES = "active-categories-repeat-incorrect-mcq";
export const STORAGE_KEY_MCQ_REPEAT_INCORRECT_SESSION_IDS = "repeat-incorrect-questions-mcq";
export const STORAGE_KEY_MCQ_REPEAT_INCORRECT_SKIPPED_IDS = "repeat-incorrect-skipped-mcq";

export const STORAGE_KEY_EMQ_SELECTED_CATEGORIES = "active-categories-emq";
export const STORAGE_KEY_EMQ_SESSION_IDS = "active-questions-emq";
export const STORAGE_KEY_EMQ_SKIPPED_IDS = "active-skipped-emq";
export const STORAGE_KEY_EMQ_PINNED_SELECTED_CATEGORIES = "active-categories-pinned-emq";
export const STORAGE_KEY_EMQ_PINNED_SESSION_IDS = "pinned-questions-emq";
export const STORAGE_KEY_EMQ_REPEAT_INCORRECT_SELECTED_CATEGORIES = "active-categories-repeat-incorrect-emq";
export const STORAGE_KEY_EMQ_REPEAT_INCORRECT_SESSION_IDS = "repeat-incorrect-questions-emq";
export const STORAGE_KEY_EMQ_REPEAT_INCORRECT_SKIPPED_IDS = "repeat-incorrect-skipped-emq";

export const STORAGE_KEY_FACT_TRAINER_SELECTED_CATEGORIES = "active-categories-fact-trainer";
export const STORAGE_KEY_FACT_TRAINER_SESSION_IDS = "active-fact-trainer";
export const STORAGE_KEY_FACT_TRAINER_ANSWERED_SESSION_IDS = "answered-fact-trainer";
export const STORAGE_KEY_FACT_TRAINER_SESSION_ANSWERED_COUNT = "fact-trainer-counter";

export const pages = {
  quizIndex: (type: QuizType): string => `/quiz/${type.toLowerCase()}`,
  quizQuestion: (type: QuizType, id: string): string => `/quiz/${type.toLowerCase()}/${id}`,
  quizPinned: (type: QuizType): string => `/quiz/${type.toLowerCase()}/pinned`,
  quizResults: (type: QuizType): string => `/quiz/${type.toLowerCase()}/results`,
};
